import { Box, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'

type ProfileRowProps = {
    label: ReactNode;
    labelFlex?: string | number;
    contentFlex?: string | number;
    minWidth?: number | string;
    alignItems?: string;
    children: React.ReactElement;
}

export const ProfileRow: FC<ProfileRowProps> = ({
    label,
    children,
    labelFlex = {
        xs: '35%',
        md: '30%',
        lg: '20%',
    },
    contentFlex = {
        xs: '65%',
        md: '70%',
        lg: '80%',
    },
    minWidth = 0,
    alignItems = 'center',
}) => <Box display="flex" flexDirection="row" width={{ xs: '100%' }} minWidth={minWidth}>
    <Box
        flexBasis={labelFlex}
        flexShrink={0}
        minWidth={0}
        display="flex"
        alignItems={alignItems}
    >
        <Typography variant="h6" noWrap>
            {label}
        </Typography>
    </Box>
    <Box
        flexBasis={contentFlex}
        flexGrow={1}
        minWidth={0}
        display="flex"
        alignItems={alignItems}
        sx={{
            overflowWrap: 'anywhere',
        }}
    >
        {children}
    </Box>
</Box>
